import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useCurrentUser } from "@/hooks/useCurrentUser";
import { PageLoader } from "@/components/ui/VinylLoader";

export const Route = createFileRoute("/me")({
  component: Me,
});

function Me() {
  const { user, profile, loading } = useCurrentUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (profile?.username) {
      navigate({ to: "/profile/$username", params: { username: profile.username }, replace: true });
      return;
    }
    // Sessão válida mas o perfil ainda não carregou/não existe: não jogue no /auth,
    // manda completar o perfil.
    if (user) {
      navigate({ to: "/settings/profile", replace: true });
      return;
    }
    navigate({ to: "/auth", replace: true });
  }, [user, profile, loading, navigate]);

  return <PageLoader />;
}
